import * as React from 'react';
import s from '../solution-page-views/solution-info/solution-info.scss';
import { PreviewMode } from './preview-context';
import { AddItem, Proportion, Box } from '@wix/design-system';
import { composer } from '../../../component-decorators/composer';
import type { TFunction } from 'i18next';

export interface ICarouselWrapperProps {
  previews: { src: string }[];
}
export class CarouselPreviewWrapper extends React.Component<
  ICarouselWrapperProps,
  any
> {
  render() {
    return (
      <PreviewMode.Consumer>
        {(value) => {
          return value.isPreview && !hasPictures(this.props) ? (
            <Box className={s.previewContainer} maxHeight={471} minHeight={171}>
              <Proportion aspectRatio={9 / 6}>
                <AddItem
                  size="large"
                  onClick={() => onClickImageAdd(value.appId)}
                >
                  <PreviewCarouselText />
                </AddItem>
              </Proportion>
            </Box>
          ) : (
            this.props.children
          );
        }}
      </PreviewMode.Consumer>
    );
  }
}

const hasPictures = ({ previews }: ICarouselWrapperProps): boolean => {
  return previews !== undefined && previews.length > 0;
};
const onClickImageAdd = (appId): void => {
  window.open(
    `https://dev.wix.com/dc3/my-apps/${appId}/market/info/basic-info`,
  );
};

const PreviewCarouselText = composer()
  .withTranslation()
  .compose(({ t }: { t?: TFunction }) =>
    t('solution.page.preview.carouselText'),
  );
